
















import Component from "vue-class-component";
import Vue from 'vue';

@Component({
    props: {
        customClass: {
            required: false,
            type: String
        },
        customId: {
            required: false,
            type: String
        },
        value: {
            required: false,
            type: String
        },
        editable: {
            default: true,
            type: Boolean
        }
    },
})

export default class ToggleInput extends Vue {
    private isReadOnly: boolean = true;
    private editable!: boolean;

    makeEditable() {
        this.editable ? this.isReadOnly = false : this.isReadOnly = true;
    }

    makeReadOnly() {
        this.isReadOnly = true;
    }
}
